export default __webpack_public_path__ + "3a0259fbd716d43854d7c8b373aeb22e.png";